import { NJModal, NJModalContent, NJButton, NJFormItem } from '@engie-group/fluid-design-system-react';
import { useState, useEffect } from 'react';
import './ModalFeedback.css';

function ModalFeedback({ isOpen, handleFeedback, handleCancel }) {

    const [comment, setComment] = useState('');

    useEffect(() => {
        setComment('');
    }, [ isOpen]);

    return (
        <NJModal
            id="modalFeedback"
            isOpen={isOpen}
        >
        <NJModalContent
        footer={
                <>
                    <NJButton
                        emphasis="bold"
                        variant="secondary"
                        label="Cancel"
                        onClick={handleCancel}
                    />
                    <NJButton
                        label="Send"
                        icon="send"
                        iconClassName="material-icons-outlined"
                        disabled={!comment}
                        onClick={() => { handleFeedback( comment) }}
                        placeholder="Your feedback"
                    />
                </>
            }
            icon="feedback"
            id="modalFeedback"
            onClose={handleCancel}
            title="App can be improved?"      
        >
            <NJFormItem
                className='dashboard-job-input-hide-label'
                label=""
                name="myInput"
                onChange={(e) => setComment(e.target.value)}   
                value={comment} 
                labelKind="static"
            />
            </NJModalContent>
        </NJModal>
    ) 
}

export default ModalFeedback;
